import { safeLocalStorage } from "~/utils";

const STORAGE_KEY = "analytics_steps_sent";

function safeParse(json: string | null): Record<string, string[]> {
	if (!json) return {};
	try {
		return JSON.parse(json);
	} catch {
		return {};
	}
}

/** Получить все сохранённые шаги */
export function getSentSteps(): Record<string, string[]> {
	if (typeof window === "undefined") return {};
	return safeParse(safeLocalStorage.getItem(STORAGE_KEY));
}

/** Проверить, был ли отправлен шаг для clientId */
export function isStepSent(clientId: string | number, step: string): boolean {
	const sentData = getSentSteps();
	const stepsForClient = sentData[String(clientId)] || [];
	return stepsForClient.includes(step);
}

/** Сохранить шаг как отправленный */
export function markStepAsSent(clientId: string | number, step: string): void {
	if (typeof window === "undefined") return;
	const sentData = getSentSteps();
	const key = String(clientId);
	const currentSteps = sentData[key] || [];
	if (!currentSteps.includes(step)) {
		sentData[key] = [...currentSteps, step];
		try {
			localStorage.setItem(STORAGE_KEY, JSON.stringify(sentData));
		} catch {
		}
	}
}

/** Очистить все сохранённые шаги (если нужно при отладке или сбросе клиента) */
export function clearSentSteps(clientId?: string | number): void {
	if (typeof window === "undefined") return;
	if (!clientId) {
		localStorage.removeItem(STORAGE_KEY);
		return;
	}
	const sentData = getSentSteps();
	delete sentData[String(clientId)];
	localStorage.setItem(STORAGE_KEY, JSON.stringify(sentData));
}
